<div class="sum-leg" *ngIf="tabsLegsToAggregate?.legs?.length > 1 && cross">
  <!-- we need to 'pad' the attribute area for the pricing results to be in the correct place -->
  <div>
    <div class="leg-header"></div>
  </div>
  <div *ngFor="let attribute of activeAttributes">
    <div class="leg-attribute-empty"></div>
  </div>

  <div class="sum-title">
    <div class="Aggregated-Risk">
      <div class="Aggregated-Risk__label">Aggregated Risk</div>
      <span *ngIf="entities.length" class="Aggregated-Risk__entity">
        Entity:
        <div class="clr-select-wrapper">
          <select
            [ngModel]="entity"
            class="clr-select"
            (change)="entityChange($any($event.target).value)"
          >
            <option *ngFor="let entityValue of entities" [value]="entityValue">
              {{ entityValue }}
            </option>
          </select>
        </div>
      </span>
    </div>
  </div>

  <div class="sum-body">
    <app-sum-results-display
      [aggregatedValues]="aggregatedValues"
      [cross]="cross"
    >
    </app-sum-results-display>
    <span *ngIf="loading" class="spinner spinner-sm spinner-inverse"> </span>
  </div>
</div>
